import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa'
import './ProjectTile.css'

const tagToneMap = {
  'Next.js': 'teal',
  React: 'teal',
  Vite: 'teal',
  Flask: 'teal',
  FastAPI: 'teal',
  Docker: 'teal',
  'Node.js': 'teal',
  Python: 'blue',
  TypeScript: 'blue',
  PostgreSQL: 'blue',
  Pandas: 'blue',
  'Scikit-learn': 'blue',
  HMM: 'coral',
  'Time Series': 'coral',
  PCA: 'coral',
  Unsupervised: 'coral',
  Classification: 'coral',
  'Recommender Systems': 'coral',
  'Data Viz': 'gold',
  'Google Cloud': 'gold',
  Finance: 'gold',
  'MLB API': 'gold',
  'Web Scraping': 'gold',
  'Claude Fable': 'coral',
  'Google OAuth': 'gold',
  'Decision Tree Algorithms': 'coral',
}

const tagToneStyles = {
  teal: {
    '--project-tag-bg': 'var(--pill-teal-bg)',
    '--project-tag-text': 'var(--pill-teal-text)',
  },
  blue: {
    '--project-tag-bg': 'var(--pill-blue-bg)',
    '--project-tag-text': 'var(--pill-blue-text)',
  },
  coral: {
    '--project-tag-bg': 'var(--pill-coral-bg)',
    '--project-tag-text': 'var(--pill-coral-text)',
  },
  gold: {
    '--project-tag-bg': 'var(--pill-gold-bg)',
    '--project-tag-text': 'var(--pill-gold-text)',
  },
}

const ProjectTile = ({
  title,
  description,
  imgSrc,
  href,
  tags = [],
  isExternal = false,
  designLanguage = 'material3',
  isGrouped = false,
}) => {
  const Wrapper = href ? 'a' : 'div'
  const actionIcon = href ? (
    <span className="project-github" aria-hidden="true">
      {isExternal ? <FaExternalLinkAlt /> : <FaGithub />}
    </span>
  ) : null
  const cardProps = {
    className: `project-tile project-tile--${designLanguage} ${href ? 'project-tile-link' : ''} ${isGrouped ? 'project-tile--grouped' : ''}`,
    ...(href
      ? {
          href,
          target: '_blank',
          rel: 'noopener noreferrer',
          title: `Open ${title}`,
        }
      : {}),
  }
  const renderTags = () => (
    <div className="project-tags">
      {tags.map((tag, idx) => (
        <span
          key={`${tag}-${idx}`}
          className="project-tag"
          style={
            designLanguage === 'material3'
              ? tagToneStyles[tagToneMap[tag] || 'teal']
              : undefined
          }
        >
          {tag}
        </span>
      ))}
    </div>
  )

  if (designLanguage === 'liquid-glass') {
    return (
      <Wrapper {...cardProps}>
        <img
          src={imgSrc}
          alt={title}
          className="project-image project-image--liquid"
        />

        <div className="project-content project-content--liquid">
          <h3 className="project-title">
            <span className="project-title-text">{title}</span>
            {actionIcon}
          </h3>

          <p className="project-description">{description}</p>

          {renderTags()}
        </div>
      </Wrapper>
    )
  }

  return (
    <Wrapper {...cardProps}>
      <div className="project-material-media">
        <img
          src={imgSrc}
          alt={title}
          className="project-image project-image--material"
        />
      </div>

      <div className="project-content project-content--material">
        <h3 className="project-title">
          <span className="project-title-text">{title}</span>
          {actionIcon}
        </h3>

        <p className="project-description">{description}</p>

        {renderTags()}
      </div>
    </Wrapper>
  )
}

export default ProjectTile
